var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.77 10.21C6.75 10.21 7.54 11 7.54 11.98C7.54 12.96 6.75 13.75 5.77 13.75C4.79 13.75 4 12.96 4 11.98C4 11 4.79 10.21 5.77 10.21ZM13.77 11.98C13.77 11 12.98 10.21 12 10.21C11.02 10.21 10.23 11 10.23 11.98C10.23 12.96 11.02 13.75 12 13.75C12.98 13.75 13.77 12.96 13.77 11.98ZM20 11.98C20 11 19.21 10.21 18.23 10.21C17.25 10.21 16.46 11 16.46 11.98C16.46 12.96 17.25 13.75 18.23 13.75C19.21 13.75 20 12.96 20 11.98Z",
  fill: "inherit"
})));
export default SvgMoreHorizontal;